import {
  AlertCircle,
  Ban,
  CheckCircle,
  Clock,
  Loader,
  RefreshCw,
  Send,
  XCircle,
} from 'lucide-react';
import { EnumTableConfig } from '@/components/table/_fieldDefinitions/enum/EnumTableConfig.ts';
import { toneEnumConfig } from '@/components/table/_fieldDefinitions/enum/enumToneConfig.ts';
import { UserMessageStatus } from '@/features/dashboard/messages/types/UserMessageStatus.ts';
import { MessageStatus } from '@/features/dashboard/messages/types/MessageEnums.ts';
import { DeliveryStatusForUser } from '@/features/dashboard/messages/types/DeliveryStatusForUser.ts';
import { MessageStatusDto } from '@/features/dashboard/messages/types/MessageStatusDto.ts';

export const mapToUserMessageStatus = (
  status: MessageStatusDto,
): UserMessageStatus => {
  switch (status.sendStatus) {
    case MessageStatus.SCHEDULED:
      return UserMessageStatus.SCHEDULED;
    case MessageStatus.PROCESSING:
      return UserMessageStatus.PROCESSING;
    case MessageStatus.SCHEDULED_FOR_RETRY:
      return UserMessageStatus.RETRYING;
    case MessageStatus.FAILED:
      return UserMessageStatus.SEND_FAILED;
    case MessageStatus.CANCELLED:
      return UserMessageStatus.CANCELLED;
    case MessageStatus.SENT:
      switch (status.deliveryStatus) {
        case DeliveryStatusForUser.DELIVERED:
          return UserMessageStatus.DELIVERED;
        case DeliveryStatusForUser.ERROR:
          return UserMessageStatus.UNDELIVERED;
        case DeliveryStatusForUser.UNKNOWN:
        default:
          return UserMessageStatus.SENT;
      }
  }
};

export const userMessageStatusTableConfig: EnumTableConfig = {
  [UserMessageStatus.SCHEDULED]: {
    ...toneEnumConfig('Zaplanowana', 'info', Clock),
    tooltip: 'Zaplanowana',
  },
  [UserMessageStatus.PROCESSING]: {
    ...toneEnumConfig('Przetwarzanie', 'warning', Loader),
    tooltip: 'Przetwarzanie',
  },
  [UserMessageStatus.RETRYING]: {
    ...toneEnumConfig('Ponowna próba', 'warning', RefreshCw),
    tooltip: 'Ponowna próba',
  },
  [UserMessageStatus.SENT]: {
    ...toneEnumConfig('Wysłana', 'info', Send),
    tooltip: 'Wysłana — oczekuje potwierdzenia dostarczenia',
  },
  [UserMessageStatus.DELIVERED]: {
    ...toneEnumConfig('Dostarczona', 'success', CheckCircle),
    tooltip: 'Dostarczona',
  },
  [UserMessageStatus.UNDELIVERED]: {
    ...toneEnumConfig('Niedostarczona', 'error', XCircle),
    tooltip: 'Niedostarczona — provider zgłosił błąd dostarczenia',
  },
  [UserMessageStatus.SEND_FAILED]: {
    ...toneEnumConfig('Błąd wysyłki', 'error', AlertCircle),
    tooltip: 'Błąd wysyłki — wiadomość nie została wysłana',
  },
  [UserMessageStatus.CANCELLED]: {
    ...toneEnumConfig('Anulowana', 'caution', Ban),
    tooltip: 'Anulowana',
  },
};
